
export const ROLES  = {
    ADMIN: "ADMIN",
    ASISA: "SUSCAGENTE",
    OCASO: "SUSCAGENTEOCASO",
    MUTUA_LEVANTE: "SUSCAGENTEMUTUALEVANTE",
};
